/*
 * ------------------------------------------------------------
 * Trilogy bundle — Disco Marshmallow (custom)
 * Cart nudge ("add one more RTS piece, save 10%") in the cart drawer
 * and cart page, with inline quick-add, and auto-applies the existing
 * "Trilogy" 10% code once 3+ RTS pieces are in the cart.
 *
 * 2026-08-23 FIX: the window.fetch wrapper below called
 * `_fetch.apply(this, arguments)`. Dawn calls fetch() unqualified from
 * inside class methods, and class bodies are always strict mode, so
 * `this` was `undefined` — native fetch then threw
 * "Illegal invocation" and Add to Cart hung forever. Now bound to
 * window, and the whole wrapper is guarded so it can never break the
 * page again.
 *
 * 2026-09-15: eligibility is now VARIANT-level, not product-level.
 * trilogy-data.liquid emits an "variants" array of eligible variant ids
 * per product; only those count toward the 3-piece threshold and only
 * those are offered in the quick-add picker. This lets the crayon
 * bracelet design pages join the promo with their $575 ready-to-ship
 * wrapper variants while their made-to-order variants (up to $7,192)
 * stay out of it — a made-to-order piece must never unlock a
 * ready-to-ship discount. Falls back to product-level behaviour for any
 * product emitted without a variants array.
 *
 * 2026-09-15b: back to 3 suggestions, at most one tier-joined product
 * (i.e. one crayon) and no two suggestions sharing a title, so the
 * duplicate RTS listings cannot both appear. Also re-inserts the nudge
 * when Dawn replaces the drawer's footer HTML after an add - that was
 * why adding a first ready-to-ship piece showed nothing until a second
 * add came along.
 * ------------------------------------------------------------
 */
(function () {
  if (window.__trilogyBundleInit) return;
  window.__trilogyBundleInit = true;

  var CODE = 'Trilogy';
  var THRESHOLD = 3;
  var MAX_PICKS = 3;
  var applied = false;
  var pcache = {};

  function readProducts() {
    var el = document.querySelector('[data-trilogy-products]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  var PRODUCTS = readProducts();
  var IDS = PRODUCTS.map(function (p) { return p.id; });

  /* Eligible variants, by product and flattened. Only these count toward
     the threshold and only these are offered in the picker. */
  var ELIG = {};
  var ELIG_ANY = {};
  PRODUCTS.forEach(function (p) {
    if (!p.variants || !p.variants.length) return;
    var m = {};
    p.variants.forEach(function (vid) { m[vid] = true; ELIG_ANY[vid] = true; });
    ELIG[p.id] = m;
  });
  var HAVE_ELIG = Object.keys(ELIG).length > 0;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;'); }
  function money(cents) { var d = cents / 100; return '$' + (d % 1 === 0 ? String(d) : d.toFixed(2)); }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  /* Count only eligible variants. If a product was emitted without a
     variants array, fall back to counting any variant of it. */
  function trilogyQty(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (ELIG_ANY[it.variant_id]) { n += it.quantity; return; }
      if (!HAVE_ELIG && IDS.indexOf(it.product_id) !== -1) { n += it.quantity; return; }
      if (HAVE_ELIG && !ELIG[it.product_id] && IDS.indexOf(it.product_id) !== -1) n += it.quantity;
    });
    return n;
  }
  function idsInCart(cart) { return (cart.items || []).map(function (it) { return it.product_id; }); }

  function applyDiscount() {
    if (applied) return;
    applied = true;
    var back = encodeURIComponent(window.location.pathname + window.location.search);
    fetch('/discount/' + CODE + '?redirect=' + back, { credentials: 'same-origin' }).catch(function () {});
  }

  /* ---------------- quick add ---------------- */
  function loadProduct(handle) {
    if (pcache[handle]) return Promise.resolve(pcache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product fetch'); return r.json(); })
      .then(function (p) {
        var allow = ELIG[p.id];
        if (allow) {
          var keep = (p.variants || []).filter(function (v) { return allow[v.id]; });
          if (keep.length) {
            var copy = {};
            for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) copy[k] = p[k]; }
            copy.variants = keep;
            p = copy;
          }
        }
        pcache[handle] = p; return p;
      });
  }

  function quickAdd(variantId) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var headers, body;
    if (cart && cart.getSectionsToRender) {
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
      body = fd;
    } else {
      headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      body = JSON.stringify({ items: [{ id: variantId, quantity: 1 }] });
    }
    return fetch('/cart/add.js', { method: 'POST', headers: headers, credentials: 'same-origin', body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'add failed');
        if (cart && cart.renderContents) {
          try { cart.renderContents(res); } catch (e) {}
        } else {
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'trilogy-quick-add', cartData: res });
            }
          } catch (e) {}
        }
        return res;
      });
  }

  function optionNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }); }
  function optionValues(p) {
    return optionNames(p).map(function (_, i) {
      var seen = {}, vals = [];
      (p.variants || []).forEach(function (v) { var val = v.options[i]; if (!(val in seen)) { seen[val] = 1; vals.push(val); } });
      return vals;
    });
  }
  function firstAvailable(p) { return (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0]; }
  function matchVariant(p, selected) {
    return (p.variants || []).find(function (v) { return selected.every(function (val, i) { return v.options[i] === val; }); });
  }
  function currentSelection(card) {
    return Array.prototype.map.call(card.querySelectorAll('[data-qa-opt]'), function (s) { return s.value; });
  }
  function updateConfirm(card, p) {
    var confirm = card.querySelector('[data-qa-confirm]');
    var note = card.querySelector('[data-qa-note]');
    if (!confirm) return;
    var v = matchVariant(p, currentSelection(card));
    if (v && v.available) {
      confirm.disabled = false; confirm.setAttribute('data-vid', v.id);
      if (note) note.hidden = true;
    } else {
      confirm.disabled = true; confirm.removeAttribute('data-vid');
      if (note) { note.hidden = false; note.textContent = v ? 'That combination is sold out.' : 'Unavailable.'; }
    }
  }
  function renderPicker(card, p) {
    var names = optionNames(p), vals = optionValues(p);
    var fa = firstAvailable(p);
    var sel = fa ? fa.options.slice() : [];
    var html = '<div class="trilogy-qa">';
    names.forEach(function (name, i) {
      /* An option left with a single value after eligibility filtering
         carries no choice — keep the select in the DOM so the option
         positions still line up, but hide the row. */
      var fixed = (vals[i] || []).length <= 1 ? ' trilogy-qa__label--fixed' : '';
      html += '<label class="trilogy-qa__label' + fixed + '">' + esc(name) +
        '<select class="trilogy-qa__select" data-qa-opt="' + i + '">' +
        vals[i].map(function (val) {
          return '<option value="' + escAttr(val) + '"' + (val === sel[i] ? ' selected' : '') + '>' + esc(val) + '</option>';
        }).join('') +
        '</select></label>';
    });
    html += '<button type="button" class="trilogy-qa__confirm" data-qa-confirm>Add to bag</button>';
    html += '<p class="trilogy-qa__note" data-qa-note hidden></p></div>';
    var existing = card.querySelector('.trilogy-qa');
    if (existing) existing.outerHTML = html; else card.insertAdjacentHTML('beforeend', html);
    updateConfirm(card, p);
  }

  function handleAdd(btn) {
    var card = btn.closest('.trilogy-nudge__card'); if (!card) return;
    var handle = card.getAttribute('data-handle'); var url = card.getAttribute('data-url');
    if (!handle) { if (url) window.location.href = url; return; }
    if (card.querySelector('.trilogy-qa')) return;
    var orig = btn.textContent; btn.disabled = true; btn.textContent = '…';
    loadProduct(handle).then(function (p) {
      if ((p.variants || []).length <= 1) {
        var v = firstAvailable(p);
        if (!v || !v.available) { btn.textContent = 'Sold out'; return; }
        return quickAdd(v.id).catch(function () { if (url) window.location.href = url; });
      }
      btn.disabled = false; btn.textContent = orig;
      renderPicker(card, p);
    }).catch(function () {
      if (url) window.location.href = url; else { btn.disabled = false; btn.textContent = orig; }
    });
  }

  function handleConfirm(btn) {
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-vid'); if (!vid) return;
    var card = btn.closest('.trilogy-nudge__card'); var url = card && card.getAttribute('data-url');
    btn.disabled = true; btn.textContent = 'Adding…';
    quickAdd(vid)
      .then(function () { var qa = card && card.querySelector('.trilogy-qa'); if (qa) qa.remove(); })
      .catch(function () { if (url) window.location.href = url; else { btn.disabled = false; btn.textContent = 'Add to bag'; } });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var add = e.target.closest('[data-qa-add]');
    if (add) { e.preventDefault(); try { handleAdd(add); } catch (err) {} return; }
    var conf = e.target.closest('[data-qa-confirm]');
    if (conf) { e.preventDefault(); try { handleConfirm(conf); } catch (err) {} }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var opt = e.target.closest('[data-qa-opt]');
    if (!opt) return;
    var card = opt.closest('.trilogy-nudge__card');
    var handle = card && card.getAttribute('data-handle');
    if (handle && pcache[handle]) updateConfirm(card, pcache[handle]);
  });

  /* ---------------- nudge render ---------------- */
  var NUDGE_HTML =
    '<p class="trilogy-nudge__headline" data-trilogy-headline></p>' +
    '<div class="trilogy-nudge__track"><span class="trilogy-nudge__fill" data-trilogy-bar></span></div>' +
    '<div class="trilogy-nudge__suggestions" data-trilogy-suggestions></div>';

  function ensureDrawerNudge() {
    var footer = document.querySelector('#CartDrawer .drawer__footer, cart-drawer .drawer__footer');
    if (!footer || footer.querySelector('[data-trilogy-nudge]')) return;
    var div = document.createElement('div');
    div.className = 'trilogy-nudge';
    div.setAttribute('data-trilogy-nudge', '');
    div.setAttribute('data-trilogy-drawer', '');
    div.hidden = true;
    div.innerHTML = NUDGE_HTML;
    footer.insertBefore(div, footer.firstChild);
  }

  function cardHTML(p) {
    return '<div class="trilogy-nudge__card" data-handle="' + escAttr(p.handle || '') + '" data-url="' + escAttr(p.url || '') + '" data-pid="' + p.id + '">' +
      (p.image ? '<img class="trilogy-nudge__card-img" src="' + escAttr(p.image) + '" alt="" width="44" height="44" loading="lazy">' : '') +
      '<span class="trilogy-nudge__card-info">' +
        '<span class="trilogy-nudge__card-title">' + esc(p.title) + '</span>' +
        '<span class="trilogy-nudge__card-price">' + money(p.price) + '</span>' +
      '</span>' +
      '<button type="button" class="trilogy-nudge__card-add" data-qa-add>Add</button>' +
    '</div>';
  }

  function paint(nudge, state) {
    if (state.qty < 1) { nudge.hidden = true; return; }
    nudge.hidden = false;
    nudge.classList.toggle('trilogy-nudge--unlocked', state.qualified);
    var head = nudge.querySelector('[data-trilogy-headline]');
    var bar = nudge.querySelector('[data-trilogy-bar]');
    var sug = nudge.querySelector('[data-trilogy-suggestions]');
    if (head) {
      head.innerHTML = state.qualified
        ? '🎉 You’ve unlocked <strong>10% off</strong> — applied at checkout.'
        : 'Add <strong>' + state.remaining + '</strong> more ready-to-ship ' +
          (state.remaining === 1 ? 'piece' : 'pieces') + ' and get <strong>10% off</strong> all three.';
    }
    if (bar) bar.style.width = Math.min(100, Math.round((state.qty / THRESHOLD) * 100)) + '%';
    if (sug) sug.innerHTML = state.qualified ? '' : state.picks.map(cardHTML).join('');
  }

  /* At most MAX_PICKS suggestions, at most one tier-joined product (so the
     list does not fill with crayon designs), and never two products sharing
     a title (which is what collapses the duplicate RTS listings). */
  function choosePicks(inCart) {
    var out = [], seenTitle = {}, tieredUsed = false;
    for (var i = 0; i < PRODUCTS.length && out.length < MAX_PICKS; i++) {
      var p = PRODUCTS[i];
      if (!p.available) continue;
      if (inCart.indexOf(p.id) !== -1) continue;
      var t = String(p.title || '').trim().toLowerCase();
      if (seenTitle[t]) continue;
      if (p.tiered) {
        if (tieredUsed) continue;
        tieredUsed = true;
      }
      seenTitle[t] = true;
      out.push(p);
    }
    return out;
  }

  function render(cart) {
    ensureDrawerNudge();
    var nudges = document.querySelectorAll('[data-trilogy-nudge]');
    if (!nudges.length) return;
    var qty = trilogyQty(cart);
    var qualified = qty >= THRESHOLD;
    var inCart = idsInCart(cart);
    if (qualified) applyDiscount(); else applied = false;
    var state = {
      qty: qty,
      qualified: qualified,
      remaining: Math.max(0, THRESHOLD - qty),
      picks: choosePicks(inCart)
    };
    nudges.forEach(function (n) {
      if (n.querySelector('.trilogy-qa')) return;
      paint(n, state);
    });
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () { getCart().then(render).catch(function () {}); }, 200);
  }

  /* Watch cart mutations WITHOUT breaking native fetch.
     Previously this reassigned window.fetch and invoked the native
     implementation with the caller's `this`, which is undefined inside
     Dawn's strict-mode class methods -> "Illegal invocation" -> Add to
     Cart hung. Bind to window and fail safe. */
  try {
    if (window.fetch && !window.__trilogyFetchWrapped) {
      window.__trilogyFetchWrapped = true;
      var _fetch = window.fetch.bind(window);
      window.fetch = function () {
        var p = _fetch.apply(null, arguments);
        try {
          var input = arguments[0];
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(url) && p && p.then) {
            p.then(function () { refresh(); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
    }
  } catch (e) {}

  function observeDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(function () { refresh(); })
      .observe(d, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
    /* Dawn replaces the drawer's inner HTML when it re-renders after an add,
       which takes our footer nudge with it. React ONLY to the nudge having
       gone missing - painting it cannot then retrigger this observer, so
       there is no feedback loop. */
    new MutationObserver(function () {
      if (!d.querySelector('[data-trilogy-nudge]')) refresh();
    }).observe(d, { childList: true, subtree: true });
  }

  /* Dawn's own cart event, where the theme exposes pubsub. Belt and braces
     alongside the fetch wrapper and the observers. */
  function subscribeCartUpdate() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
      }
    } catch (e) {}
  }

  function init() { observeDrawer(); subscribeCartUpdate(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
